import React, {useEffect, useState} from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
// core components

import styles from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";
import CustomDropdown from "./CustomDropdown";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import {useSelector, useDispatch} from "react-redux";
import { setActiveStore } from "../../store/app/actions";

const useStyles = makeStyles(styles);
export default function MarketSelector(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const onChange = (e) => {
    if(props.setActiveStore){
      dispatch(setActiveStore(e.target.value))
    }
    if(props.onChange){
      props.onChange(e)
    }
  }

  const onClick = (e) => {
    if(props.onClick){
      props.onClick(e)
    }
  }

  const [availableOptions, setAvailableOptions] = useState([])
  const locations = useSelector(state => state.app.stores)
  const activeStore = useSelector(state => state.app.activeStore)
  useEffect( () => {
    setAvailableOptions(locations.filter( location => {
      if(!props.showDisabled && location.disabled){
        return false
      }
      if(!props.showRetail && location.type==='retail'){
        return false
      }
      return true
    }).map(location => ({value:props.useFullID?location.id:location.store_id, display:props.onlyShowStoreID?location.store_id:location.store_id+" - "+location.name})))
  }, [locations, props.showDisable, props.showRetail])
  if(!locations || locations.length === 0){
    return null;
  }
  return (
    <FormControl className={classes.selectFormControl}>
      <InputLabel
        htmlFor="select"
        className={classes.selectLabel}
      >
        {props.label||"Location"}
      </InputLabel>
      <Select
        autoWidth
        multiple={!!props.multiple}
        value={props.value !== undefined ? props.value : (activeStore || "")}
        onChange={onChange}
        onClick={onClick}
        MenuProps={{ className: classes.selectMenu }}
        classes={{ select: classes.select }}
        inputProps={{
          name: "multipleSelect",
          id: "multiple-select",
        }}
      >
        {availableOptions.map((option, i) => {
          return <MenuItem
            key={`market_selector_${i}`}
            classes={{
              root: classes.selectMenuItem,
              selected: classes.selectMenuItemSelectedMultiple,
            }}
            value={option.value}
          >
            {option.display}
          </MenuItem>
        })}
      </Select>
    </FormControl>
  );
}

MarketSelector.defaultProps = {
  showDisable: true,
  showRetail: true,
  multiple: false,
  useFullID: false,
  onlyShowStoreID: false
};

MarketSelector.propTypes = {
  onChange: PropTypes.func,
  showDisabled: PropTypes.bool,
  showRetail: PropTypes.bool,
  multiple: PropTypes.bool,
  useFullID: PropTypes.bool,
  onlyShowStoreID: PropTypes.bool,
};